import { Type } from 'class-transformer';
import { VendorHeaderTemplateRawDto } from '../../../shared-workflow-module/_models/vendor-header-template-raw-dto';
import { VendorLineItemTemplateRawDto } from '../../../shared-workflow-module/_models/vendor-lineItem-template-raw-dto';

export class WFEVendorAccountTemplateResultDto {
    @Type(() => VendorHeaderTemplateRawDto)
    headerTemplate: VendorHeaderTemplateRawDto;

    @Type(() => VendorLineItemTemplateRawDto)
    lineItemTemplates: Array<VendorLineItemTemplateRawDto>;
}
